import React, { useContext, useEffect, useMemo, useState } from "react";
import RtlProvider from "../../../Components/RtlProvider";
import { ContextNotification, severitys } from "../../../App";
import { Box, Button, Modal, Paper, Typography } from "@mui/material";
import { ContextUserInfo } from "../MainPanel";
import AccessControl from "../../../Components/AccessControl";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import bedReservationApi from "../../../api/bedReservationApi";
import BedReservationForm from "./BedReservationForm";
import { MdCheck } from "react-icons/md";
import { HiXMark } from "react-icons/hi2";
import UpdateReserveEventForm from "./UpdateReserveEventForm";
import enumMapper from "../../../enumMapper";
import UpdateBedReservationDateForm from "./UpdateBedReservationDateForm";
import BedActivateForm from "./BedActivateForm";

const AllBedsByRoomId = ({ roomid }) => {
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const { open, setOpen } = useContext(ContextNotification);
  // const [rows, setRows] = useState([]);
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false);
  const [loadingRows, setLoadingRows] = useState(false);

  const [selectedBed, setSelectedBed] = useState(null);
  const [selectedBedReservation, setSelectedBedReservation] = useState(null)

  useEffect(() => {
    GetData();
  }, [refresh]);
  const RefreshGrid = (result) => {
    if (result)
      setRefresh(old => !old);
    handleCloseBedReservationModal();
    handleCloseUpdateBedReservationDateModal();
  }

  const GetData = () => {
    setLoadingRows(true);
    bedReservationApi.GetAllBedsByRoomId(roomid)
      .then((res) => {
        // const arr = helper.DictionayToList(res.data.data);
        setData(res.data.data)
      })
      .catch((error) => console.log(error))
      .finally(() => setLoadingRows(false));
  };

  const columns = useMemo(
    () => [


      // {
      //   accessorKey: 'id',
      //   header: 'id',
      //   size: 100,
      // },
      {
        accessorKey: 'code',
        header: 'کد',
        size: 100,
      },
      {
        accessorKey: 'isActive',
        id: 'isActive',
        header: 'فعال',
        Cell: ({ cell, row }) => (
          row.original.isActive ? <MdCheck size={25} color='green' /> : <HiXMark />
        ),
        size: 100,
        enableSorting: false,
      },

      {
        accessorKey: 'isRoomFreeToday',
        id: 'isRoomFreeToday',
        header: 'آزاد (امروز)',
        Cell: ({ cell, row }) => (
          row.original.isRoomFreeToday ? <MdCheck size={25} color='green' /> : <HiXMark />
        ),
        size: 100,
        enableSorting: false,
      },

    ],
    [],
  );

  const subColumns = useMemo(
    () => [
      {
        accessorKey: 'firstName',
        header: 'نام',
        size: 100,
      },
      {
        accessorKey: 'familyName',
        header: 'نام خانوادگی',
        size: 100,
      },
      {
        accessorKey: 'ssn',
        header: 'کد ملی',
        size: 100,
      },
      {
        accessorKey: 'from_persian',
        header: 'از',
        size: 100,
      },
      {
        accessorKey: 'to_persian',
        header: 'تا',
        size: 100,
      },
      {
        accessorKey: 'reserveEventTitle',
        header: 'وضعیت',
        size: 100,
      },
      //       {
      //   accessorKey: 'passengerId',
      //   header: 'passengerId',
      //   size: 100,
      // },

    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data,
    initialState: {
      sorting: [

      ],
    },
    state: {
      isLoading: loadingRows,
    },
    enableExpandAll: false,
    enableRowSelection: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enablePagination: false,
    enableSorting: true,
    enableColumnActions: false,

    mrtTheme: (theme) => ({
      baseBackgroundColor: theme.palette.background.default, //change default background color
    }),

    muiTableProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',

      },
    },
    muiTableHeadCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        backgroundColor: '#ffe0b2',
        fontWeight: 'bold',
        textAlign: 'left'
      },
    },
    muiTableBodyCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        textAlign: 'left'
      },
    },
    enableRowActions: true,
    positionActionsColumn: 'last',
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: '', //change header text


      },
      'mrt-row-expand': {
        header: '', //change header text

      }
    },

    //conditionally render detail panel
    renderDetailPanel: ({ row: parentRow }) =>

      parentRow.original.bedReservationInfo.length > 0 ? (


        <Box
          sx={{
            margin: 'auto',
            width: '100%',
          }}
        >
          <Typography variant="h6" gutterBottom component="div" style={{ textAlign: "right" }}>
            وضعیت رزرو تخت
          </Typography>
          {
            <MaterialReactTable
              columns={subColumns}
              data={parentRow.original.bedReservationInfo}
              enableSelectAll={false}
              enableRowActions={true}
              positionActionsColumn='last'
              enableTopToolbar={false}
              enableBottomToolbar={false}
              enablePagination={false}
              enableSorting={false}
              enableColumnActions={false}
              mrtTheme={(theme) => ({
                baseBackgroundColor: theme.palette.background.default, //change default background color
              })}
              muiTableProps={
                {
                  sx: {
                    width: 'auto',

                  }
                }
              }
              muiTableHeadCellProps={{
                sx: {
                  border: '1px solid rgba(81, 81, 81, .5)',
                  backgroundColor: '#ffe0b2',
                  fontWeight: 'bold',
                  textAlign: 'left'
                }
              }
              }
              muiTableBodyCellProps={
                {
                  sx: {
                    border: '1px solid rgba(81, 81, 81, .5)',
                    textAlign: 'left',
                  }
                }
              }
              muiTablePaperProps={
                {
                  sx: { backgroundColor: 'transparent', boxShadow: 'none' }
                }
              }
              displayColumnDefOptions={{
                'mrt-row-actions': {
                  header: '', //change header text

                },
              }}
              renderRowActions={({ row, table }) => (
                <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>

                  {
                    AccessControl.checkPermissions(userPermissions, ["BedReservation:UpdateReserveEvent"]) &&
                    row.original.reserveEvent === enumMapper.ReserveEvent.Reserve &&
                    <UpdateReserveEventForm disabled={!parentRow.original.isActive} id={row.original.id} isReserve={false} refreshGrid={RefreshGrid} />
                  }
                  {
                    AccessControl.checkPermissions(userPermissions, ["BedReservation:UpdateReserveEvent"]) &&
                    row.original.reserveEvent === enumMapper.ReserveEvent.Cancel &&
                    <UpdateReserveEventForm disabled={!parentRow.original.isActive} id={row.original.id} isReserve={true} refreshGrid={RefreshGrid} />
                  }

                  {
                    AccessControl.checkPermissions(userPermissions, ["BedReservation:UpdateBedReservationDate"]) &&

                    <Button disabled={!parentRow.original.isActive || row.original.reserveEvent === enumMapper.ReserveEvent.Cancel} variant="contained" color="secondary" onClick={() => {
                      handleOpenUpdateBedReservationDateModal(row.original)
                    }} sx={{ whiteSpace: 'nowrap' }}>
                      ویرایش تاریخ
                    </Button>
                  }
                </Box>

              )}
            />
          }
        </Box>
      ) : null,

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>

        {
          <Button disabled={!row.original.isActive} variant="contained" onClick={() => {
            handleOpenBedReservationModal(row.original)
          }} sx={{ whiteSpace: 'nowrap', marginLeft: 1 }}>
            رزرو
          </Button>
        }
        {
          AccessControl.checkPermissions(userPermissions, ["Bed:BedActivate"]) &&
          row.original.isActive && <BedActivateForm id={row.original.id} isActive={false} refreshGrid={RefreshGrid} />
        }
        {
          AccessControl.checkPermissions(userPermissions, ["Bed:BedActivate"]) &&
          !row.original.isActive && <BedActivateForm id={row.original.id} isActive={true} refreshGrid={RefreshGrid} />
        }
      </Box>
    ),
  });

  //BedReservation
  const [openBedReservationModal, setOpenBedReservationModal] = useState(false);
  const handleOpenBedReservationModal = (row) => {
    if (row) {
      setSelectedBed(row)
      setOpenBedReservationModal(true)
    }
  };
  const handleCloseBedReservationModal = () => {

    setSelectedBed(null);
    setOpenBedReservationModal(false);
  };

  //UpdateBedReservationDate
  const [openUpdateBedReservationDateModal, setOpenUpdateBedReservationDateModal] = useState(false);
  const handleOpenUpdateBedReservationDateModal = (row) => {
    console.log("row", row)
    if (row) {
      setSelectedBedReservation(row)
      setOpenUpdateBedReservationDateModal(true)
    }
  };
  const handleCloseUpdateBedReservationDateModal = () => {

    setSelectedBedReservation(null);
    setOpenUpdateBedReservationDateModal(false);
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '400px',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 6,
  };

  return (
    <>
      <MaterialReactTable table={table} />
      <Modal
        open={openBedReservationModal}
        onClose={handleCloseBedReservationModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <RtlProvider>
          <Box sx={style}>
            <Box id="modal-modal-description" sx={{ mt: 2 }}>
              {selectedBed && <BedReservationForm bedId={selectedBed.id} refreshGrid={RefreshGrid} />}
            </Box>
          </Box>
        </RtlProvider>
      </Modal>
      <Modal
        open={openUpdateBedReservationDateModal}
        onClose={handleCloseUpdateBedReservationDateModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <RtlProvider>
          <Box sx={style}>

            <Box id="modal-modal-description" sx={{ mt: 2 }}>
              {selectedBedReservation && <UpdateBedReservationDateForm row={selectedBedReservation} refreshGrid={RefreshGrid} />}
            </Box>
          </Box>
        </RtlProvider>
      </Modal>
    </>
  );
}

export default AllBedsByRoomId;
